import { cloneDeep } from 'lodash'

export default function tasksInOrder (state) {
  const rankField = state.migrations?.addRank ? 'rank' : 'createdAt'

  return cloneDeep(state.tasks).sort((a, b) => a[rankField].localeCompare(b[rankField]))
}
